import PropTypes from 'prop-types';
import { useState } from 'react';import { NavLink as RouterLink } from 'react-router-dom';
// @mui
import WebIcon from '@mui/icons-material/Web';
import HouseIcon from '@mui/icons-material/House';
import DataThresholdingIcon from '@mui/icons-material/DataThresholding';
import PersonOutlineIcon from '@mui/icons-material/PersonOutline';
import DashboardCustomizeIcon from '@mui/icons-material/DashboardCustomize';
import { Box, List, ListItemText, IconButton, Collapse, Divider, Tooltip } from '@mui/material';
import MenuIcon from '@mui/icons-material/Menu';
//
import { StyledNavItem, StyledNavItemIcon } from './styles';

// ----------------------------------------------------------------------

NavSection.propTypes = {
  data: PropTypes.array,
  collapsed: PropTypes.bool,
};

export default function NavSection({ data = [], collapsed = false, ...other }) {

  return (
    <Box {...other}>
      <Divider />
        <List disablePadding sx={{ p: 1 }}>
          {data.map((item) => (
            <NavItem key={item.title} item={item} collapsed={collapsed} />
          ))}
        </List>
    </Box>
  );
}

// ----------------------------------------------------------------------

NavItem.propTypes = {
  item: PropTypes.object,
  collapsed: PropTypes.bool,
};

function getIcon(icon) {
  switch (icon) {
    case 'web':
      return <WebIcon />;
    case 'home':
      return <HouseIcon />;
    case 'rules':
      return <DataThresholdingIcon />;
    case 'workspace':
      return <DashboardCustomizeIcon />;
    case 'account':
      return <PersonOutlineIcon />;
    default:
      return <WebIcon />;
  }
}

function NavItem({ item, collapsed }) {
  const { title, path, icon, info } = item;

  const content = (
    <StyledNavItem
      component={RouterLink}
      to={path}
      sx={{
        justifyContent: collapsed ? 'center' : 'initial',
        px: collapsed ? 1 : 2.5,
        '&.active': {
          color: 'text.primary',
          bgcolor: 'action.selected',
          fontWeight: 'fontWeightBold',
        },
      }}
    >
      <StyledNavItemIcon sx={{ mr: collapsed ? 0 : 2, minWidth: 'auto' }}>{getIcon(icon)}</StyledNavItemIcon>
      {!collapsed && <ListItemText disableTypography primary={title} />}
      {!collapsed && info && info}
    </StyledNavItem>
  );

  if (collapsed) {
    return (
      <Tooltip title={title} placement="right">
        {content}
      </Tooltip>
    );
  }

  return content;
}
